import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-12 pb-4 md:pt-16 md:pb-8 px-4 overflow-hidden relative" data-id="element-72">
      <div className="max-w-7xl mx-auto text-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-8 md:mb-12 relative z-10" data-id="element-74">
          <h1 className="text-5xl md:text-7xl font-bold text-olive-dark mb-2 font-serif leading-tight" data-id="element-75">
            Sistema PRO:
          </h1>
          <h2 className="text-4xl md:text-6xl font-bold text-golden font-serif leading-tight" data-id="element-76">
            Terapeuta
            <br data-id="element-77" />
            Ocupacional
          </h2>
        </motion.div>

        {/* Product Mockup Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto flex justify-center items-center" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/8xA5PvBaVYQcFCJKgb2ZFH/Firefly_Gemini_Flash_Okey_ahora_cambiale_los_colores_70887-Photoroom.png" alt="Sistema PRO: Terapeuta Ocupacional - Libro, tablet y módulos del sistema" className="w-full max-w-2xl h-auto object-contain drop-shadow-2xl" data-id="element-79" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-6 text-lg md:text-xl text-olive/80 max-w-2xl mx-auto font-medium text-center" data-id="element-80">
          Recursos avanzados y guías clínicas para profesionales que acompañan
          procesos de vida.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-6 md:mt-8 relative z-40" data-id="element-81">
          <a href="#comprar" className="inline-block bg-golden hover:bg-golden-hover text-white px-10 py-5 rounded-full md:text-xl font-bold uppercase tracking-widest transition-all shadow-[0_0_30px_rgba(74,144,196,0.4)] hover:shadow-[0_0_40px_rgba(74,144,196,0.6)] hover:-translate-y-1 text-[12px] pt-[20px] pb-[20px]" data-id="element-82">
            👉Acceder al sistema PRO ahora
          </a>
        </motion.div>
      </div>
    </section>;
}